// fade-on-scroll.js — HommeParadis
(function(){
  document.addEventListener('DOMContentLoaded', function () {
    // selectors to auto-apply fade class to — adjust if needed
    var selectors = [
      '.section',              // general sections
      '.product-card',         // product cards (common)
      '.card',                 // theme cards
      '.grid__item',           // grid items
      '.collection-item',      // collection item
      '.featured-collection',  // featured collection wrapper
      '.product-item',         // product item variations
      '.rte',                  // rich text blocks
      '.image-with-text',      // image text sections
      'h2',                    // headings (be careful)
      '.section__header'       // section headers
    ];

    // find elements and add hp-fade-up if not present
    var els = [];
    selectors.forEach(function(sel){
      try {
        document.querySelectorAll(sel).forEach(function(node){
          // don't spam small repeated nodes like all <h2> in site; only add if element is in main content area
          if (!node.closest('header') && !node.closest('footer')) {
            if (!node.classList.contains('hp-fade-up')) {
              node.classList.add('hp-fade-up');
            }
            els.push(node);
          }
        });
      } catch(e){}
    });

    // IntersectionObserver to toggle hp-visible
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('hp-visible');
        }
      });
    }, { threshold: 0.15 });

    els.forEach(function(el){
      io.observe(el);
    });

    // If no elements found, try product grid items specifically (fallback)
    if (els.length === 0) {
      document.querySelectorAll('.product-card, .grid__item, .card').forEach(function(item){
        item.classList.add('hp-fade-up');
        io.observe(item);
      });
    }
  });
})();
